/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
"use strict";
function makeEnum(values) {
    return values.reduce(function (obj, v) {
        obj[v] = v;
        return obj;
    }, {});
}
exports.makeEnum = makeEnum;



//////////////////
// WEBPACK FOOTER
// ./~/plottable/build/src/utils/makeEnum.js
// module id = 33
// module chunks = 0